var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 24.1383V25.1052C36.0001 25.3086 35.8359 25.4729 35.6324 25.4729H35.0942V23.7705H35.6324C35.8358 23.7706 36.0001 23.9349 36.0001 24.1383Z",
    fill: "#F2CA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 24.1383V25.1052C36.0001 25.3086 35.8359 25.4729 35.6324 25.4729H35.0942V23.7705H35.6324C35.8358 23.7706 36.0001 23.9349 36.0001 24.1383Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.084 21.6133V25.1072H3.06421V24.8334H2.47119V23.0997H3.06421V21.6133H24.084Z",
    fill: "#585757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4522 23.0987V25.4739C35.4522 25.7556 35.2238 25.9839 34.9422 25.9839H23.2227V23.0986H35.4522V23.0987Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60233 23.0996V24.8333H2.15861C2.02516 24.8333 1.91699 24.7251 1.91699 24.5917V23.3412C1.91699 23.2078 2.02516 23.0996 2.15861 23.0996H2.60233Z",
    fill: "#737AE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9618 8.46777H0V22.6671H22.9618V8.46777Z",
    fill: "#F2CA52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9618 8.46777H0V22.6671H22.9618V8.46777Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4522 20.6226V23.2039H23.2227V12.0947H28.7215C29.114 12.0947 29.4909 12.2571 29.7526 12.5496C30.6063 13.5035 31.3427 15.1244 31.9582 17.4475L34.8587 19.4816C35.2307 19.7425 35.4522 20.1683 35.4522 20.6226Z",
    fill: "#737AE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8758 17.9868H25.7515V13.4102H26.2991C28.8276 13.4102 30.8758 15.4599 30.8758 17.9868Z",
    fill: "#636799"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8758 17.9868H25.7515V13.4102H26.2991C28.8276 13.4102 30.8758 15.4599 30.8758 17.9868Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1577 19.2551C26.9624 19.3647 26.7574 19.4219 26.5429 19.4219C26.3381 19.4219 26.1236 19.3695 25.9092 19.2599L26.0188 18.8691C26.3428 19.0407 26.6764 19.0264 27.0148 18.8691L27.1577 19.2551Z",
    fill: "#737AE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1577 19.2551C26.9624 19.3647 26.7574 19.4219 26.5429 19.4219C26.3381 19.4219 26.1236 19.3695 25.9092 19.2599L26.0188 18.8691C26.3428 19.0407 26.6764 19.0264 27.0148 18.8691L27.1577 19.2551Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.061 24.5721C28.061 26.2078 29.3852 27.532 31.0213 27.532C32.6567 27.532 33.9809 26.2078 33.9809 24.5721C33.9809 22.9363 32.6567 21.6123 31.0213 21.6123C29.3852 21.6123 28.061 22.9363 28.061 24.5721Z",
    fill: "#737AE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.061 24.5721C28.061 26.2078 29.3852 27.532 31.0213 27.532C32.6567 27.532 33.9809 26.2078 33.9809 24.5721C33.9809 22.9363 32.6567 21.6123 31.0213 21.6123C29.3852 21.6123 28.061 22.9363 28.061 24.5721Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5479 24.5638C29.5479 25.3809 30.2121 26.0449 31.0292 26.0449C31.8293 26.0449 32.4932 25.3809 32.4932 24.5638C32.4932 23.7467 31.8293 23.0996 31.0292 23.0996C30.2121 23.0996 29.5479 23.7466 29.5479 24.5638Z",
    fill: "#969696"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5479 24.5635C29.5479 24.6797 29.5585 24.7906 29.59 24.8961C29.7907 24.8539 29.9966 24.912 30.1075 25.1021C30.2131 25.287 30.1656 25.5034 30.023 25.6514C30.1815 25.7992 30.3715 25.9101 30.5828 25.9788C30.6409 25.7833 30.8046 25.6302 31.0212 25.6302C31.2376 25.6302 31.4012 25.7833 31.4594 25.9841C31.6708 25.9154 31.8608 25.8045 32.0192 25.6514C31.8766 25.5034 31.829 25.2922 31.9347 25.1021C32.0456 24.912 32.2515 24.8539 32.4523 24.8961C32.4839 24.7905 32.4944 24.6797 32.4944 24.5635C32.4944 24.4526 32.4839 24.3469 32.4574 24.2466C32.2568 24.2941 32.0456 24.2308 31.9347 24.046C31.8237 23.8559 31.8766 23.6341 32.0192 23.4862C31.8608 23.3436 31.6708 23.2327 31.4594 23.1641C31.3962 23.3648 31.2376 23.5179 31.0212 23.5179C30.8045 23.5179 30.6461 23.3648 30.5828 23.1694C30.3662 23.238 30.1762 23.3489 30.0177 23.4915C30.1656 23.6446 30.2131 23.8612 30.1074 24.046C30.0018 24.2256 29.7853 24.2889 29.5846 24.2466C29.5585 24.3469 29.5479 24.4526 29.5479 24.5635Z",
    fill: "#E8E8E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80859 24.5721C3.80859 26.2078 5.13276 27.532 6.76882 27.532C8.40425 27.532 9.72843 26.2078 9.72843 24.5721C9.72843 22.9363 8.40425 21.6123 6.76882 21.6123C5.13276 21.6123 3.80859 22.9363 3.80859 24.5721Z",
    fill: "#737AE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80859 24.5721C3.80859 26.2078 5.13276 27.532 6.76882 27.532C8.40425 27.532 9.72843 26.2078 9.72843 24.5721C9.72843 22.9363 8.40425 21.6123 6.76882 21.6123C5.13276 21.6123 3.80859 22.9363 3.80859 24.5721Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29541 24.5638C5.29541 25.3809 5.95961 26.0449 6.77679 26.0449C7.5769 26.0449 8.24072 25.3809 8.24072 24.5638C8.24072 23.7467 7.5769 23.0996 6.77679 23.0996C5.95961 23.0996 5.29541 23.7466 5.29541 24.5638Z",
    fill: "#969696"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29541 24.5635C5.29541 24.6797 5.30602 24.7906 5.33754 24.8961C5.53826 24.8539 5.74421 24.912 5.85506 25.1021C5.96069 25.287 5.91318 25.5034 5.77057 25.6514C5.92901 25.7992 6.11905 25.9101 6.33038 25.9788C6.38842 25.7833 6.55216 25.6302 6.76872 25.6302C6.9852 25.6302 7.14879 25.7833 7.20698 25.9841C7.41831 25.9154 7.60835 25.8045 7.76678 25.6514C7.62418 25.5034 7.5766 25.2922 7.6823 25.1021C7.79315 24.912 7.9991 24.8539 8.19982 24.8961C8.23142 24.7905 8.24195 24.6797 8.24195 24.5635C8.24195 24.4526 8.23134 24.3469 8.20497 24.2466C8.00433 24.2941 7.79315 24.2308 7.6823 24.046C7.57129 23.8559 7.62418 23.6341 7.76678 23.4862C7.60835 23.3436 7.41831 23.2327 7.20698 23.1641C7.14371 23.3648 6.9852 23.5179 6.76872 23.5179C6.55208 23.5179 6.39365 23.3648 6.33038 23.1694C6.11374 23.238 5.92371 23.3489 5.76527 23.4915C5.91318 23.6446 5.96061 23.8612 5.85498 24.046C5.74936 24.2256 5.53288 24.2889 5.33216 24.2466C5.30594 24.3469 5.29541 24.4526 5.29541 24.5635Z",
    fill: "#E8E8E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2833 24.362V25.2491C20.2833 25.8468 19.7982 26.3319 19.2005 26.3319H13.2281C12.6304 26.3319 12.147 25.8468 12.147 25.2491V24.362C12.147 23.7643 12.6304 23.2793 13.2281 23.2793H19.2005C19.7982 23.2793 20.2833 23.7643 20.2833 24.362Z",
    fill: "#969696"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2878 23.2793H14.1416V26.3321H18.2878V23.2793Z",
    fill: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 23.4629H23.7246V23.9429H26.8931V23.4629Z",
    fill: "#F2CA52"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 23.4629H23.7246V23.9429H26.8931V23.4629Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 24.0195H23.7246V24.4995H26.8931V24.0195Z",
    fill: "#F2CA52"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 24.0195H23.7246V24.4995H26.8931V24.0195Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 24.582H23.7246V25.062H26.8931V24.582Z",
    fill: "#F2CA52"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 24.582H23.7246V25.062H26.8931V24.582Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 25.1416H23.7246V25.6216H26.8931V25.1416Z",
    fill: "#F2CA52"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8931 25.1416H23.7246V25.6216H26.8931V25.1416Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.96582 10.8441V9.91406H21.9958L0.96582 10.8441Z",
    fill: "#F2CA52"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.96582 10.8441V9.91406H21.9958L0.96582 10.8441Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9958 20.2939V21.2239H0.96582L21.9958 20.2939Z",
    fill: "#F2CA52"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9958 20.2939V21.2239H0.96582L21.9958 20.2939Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.a0c09a36fbedfb52fbb5a917a2b5a784.svg";
export { ForwardRef as ReactComponent };